import React, { useState } from 'react';
import api from '../api';

export default function LoginPage({ onLogin }) {
  // ОНОВЛЕНО: Тепер пошта і пароль стоять по замовчуванню
  const [email, setEmail]       = useState('admin@okolitsya.com.ua');
  const [password, setPassword] = useState('OkolitsyaLen4423');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      if (res.data.user.role !== 'admin') {
        setError('Доступ тільки для адміністраторів');
        return;
      }
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_user', JSON.stringify(res.data.user));
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Помилка входу');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '11px 14px',
    border: '1px solid var(--border)', borderRadius: 10,
    fontSize: 14, background: '#fff', color: 'var(--ink)',
    outline: 'none', transition: 'border-color 0.15s, box-shadow 0.15s',
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--ink)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div className="fade-up" style={{
        background: '#fff', borderRadius: 20,
        padding: '40px 36px', width: 380,
        boxShadow: '0 24px 60px rgba(0,0,0,0.3)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 52, height: 52, background: 'var(--highlight)',
            borderRadius: 14, display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center',
            fontFamily: "'Fraunces', serif", fontSize: 22,
            color: 'var(--ink)', marginBottom: 14,
          }}>R</div>
          <div style={{ fontFamily: "'Fraunces', serif", fontSize: 22, fontWeight: 400, color: 'var(--ink)' }}>
            Адмін панель
          </div>
          {/* ОНОВЛЕНО: Змінили назву ресторану */}
          <div style={{ fontSize: 13, color: 'var(--stone)', marginTop: 4, fontWeight: 300 }}>
            Ресторан «Околиця»
          </div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ fontSize: 12, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 6 }}>
              EMAIL
            </label>
            <input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="admin@okolitsya.com.ua"
              style={inputStyle}
              onFocus={e => { e.target.style.borderColor = 'var(--sand)'; e.target.style.boxShadow = '0 0 0 3px rgba(200,184,154,0.2)'; }}
              onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          <div>
            <label style={{ fontSize: 12, color: 'var(--stone)', fontWeight: 500, display: 'block', marginBottom: 6 }}>
              ПАРОЛЬ
            </label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={inputStyle}
              onFocus={e => { e.target.style.borderColor = 'var(--sand)'; e.target.style.boxShadow = '0 0 0 3px rgba(200,184,154,0.2)'; }}
              onBlur={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }}
            />
          </div>

          {error && (
            <div style={{
              background: 'var(--danger2)', color: 'var(--danger)',
              padding: '10px 14px', borderRadius: 8, fontSize: 13,
            }}>
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading ? 'var(--stone)' : 'var(--ink)',
              color: '#fff', border: 'none', borderRadius: 10,
              padding: '13px', fontSize: 14, fontWeight: 500,
              marginTop: 4, transition: 'background 0.15s',
            }}
          >
            {loading ? 'Вхід...' : 'Увійти'}
          </button>
        </form>
      </div>
    </div>
  );
}
